import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DataSubjectRequest, DataSubjectRequestCreate, DataSubjectRequestFilter } from '../data/dataSubjectRequest';

export function createDataSubjectRequestService(client: AxiosInstance) {
  return createCrudService<DataSubjectRequest, DataSubjectRequestCreate, DataSubjectRequestFilter>(
    client,
    '/audit/DataSubjectRequest',
    'id',
  );
}

export type DataSubjectRequestService = CrudService<DataSubjectRequest, DataSubjectRequestCreate, DataSubjectRequestFilter>;
